import { range } from 'lodash';

const PAGE_SIZE = 20;
const MORE_PAGES = -1;

const getPaginationPages = (totalCount: number, currentPage: number): Array<number> => {
  const PAGE_NEIGHBORS = 2;

  const pageNeighbors = Math.max(0, Math.min(PAGE_NEIGHBORS, 2));
  const totalPages = Math.ceil(totalCount / PAGE_SIZE);

  // The total page numbers to show on the control
  const totalNumbers = pageNeighbors * 2 + 3;
  // totalNumbers + 2 to cover for the left(<) and right(>) controls
  const totalBlocks = totalNumbers + 2;

  if (totalPages > totalBlocks) {
    const startPage = Math.max(2, currentPage - pageNeighbors);
    const endPage = Math.min(totalPages - 1, currentPage + pageNeighbors);
    let pages = range(startPage, endPage + 1);

    //  has hidden pages to the left
    const hasLeftSpill = startPage > 2;
    // has hidden pages to the right
    const hasRightSpill = totalPages - endPage > 1;
    // number of hidden pages either to the left or to the right
    const spillOffset = totalNumbers - (pages.length + 1);

    switch (true) {
      // handle: (1) < {5 6} [7] {8 9} (10)
      case hasLeftSpill && !hasRightSpill: {
        const extraPages = range(startPage - spillOffset, startPage - 1);
        pages = [MORE_PAGES, ...extraPages, ...pages];
        break;
      }
      // handle: (1) {2 3} [4] {5 6} > (10)
      case !hasLeftSpill && hasRightSpill: {
        const extraPages = range(endPage + 1, endPage + spillOffset);
        pages = [...pages, ...extraPages, MORE_PAGES];
        break;
      }
      // handle: (1) < {4 5} [6] {7 8} > (10)
      case hasLeftSpill && hasRightSpill:
      default: {
        pages = [MORE_PAGES, ...pages, MORE_PAGES];
        break;
      }
    }

    return [1, ...pages, totalPages];
  }

  return range(1, totalPages + 1);
};

export default getPaginationPages;
